'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withNewAssetActions from 'DesignFinderUI/components/actions/withNewAssetActions';

class NewActionsList extends PureComponent {
  render() {
    const {
      NewAssetForm,
      NewAssetActionsList
    } = this.props;
    return NewAssetForm || NewAssetActionsList;
  }

}

NewActionsList.displayName = 'NewActionsList';
NewActionsList.propTypes = {
  NewAssetActionsList: PropTypes.node,
  NewAssetForm: PropTypes.node
};
NewActionsList.defaultProps = {
  NewAssetActionsList: null,
  NewAssetForm: null
};
export default withNewAssetActions(NewActionsList);